import { localizedReturnUrl } from "./manufacturingLanguage.js";
import { productThumbnail } from "./costSheetPrint.js";

export async function printProductionOrderAlbaran({ documents = [], includeDocuments = true, getDocumentUrl, language = "es-zh", ...model }) {
  const { buildAlbaranPdf, appendAttachment } = await import("./manufacturingDocuments.js");
  const thumbnail = await productThumbnail(model.suborder?.product, 720);
  const qr = model.returnUrl ? (await import('qrcode')).default.create(localizedReturnUrl(model.returnUrl, language), { errorCorrectionLevel: 'M' }).modules : null;
  const pdf = await buildAlbaranPdf({ ...model, language, thumbnail, qr });
  // Request one printed copy; keep each delivery-note page only once.
  pdf.catalog.getOrCreateViewerPreferences().setNumCopies(1);
  const attachedFiles = [];
  if (includeDocuments) for (const doc of documents) {
    const url = await getDocumentUrl(doc);
    if (!url) throw new Error(`No se puede acceder a ${doc.title}`);
    let response;
    try { response = await fetch(url); } catch { throw new Error(`No se puede cargar ${doc.title}. Si es un enlace externo, sube el archivo al proceso para permitir su impresión.`); }
    if (!response.ok) throw new Error(`No se pudo cargar ${doc.title} (${response.status})`);
    const bytes = new Uint8Array(await response.arrayBuffer());
    // A file may be linked more than once (even under different signed URLs).
    if (attachedFiles.some((previous) => previous.length === bytes.length && previous.every((value, index) => value === bytes[index]))) continue;
    await appendAttachment(pdf, bytes, doc.mime_type || response.headers.get("content-type") || "", doc.title);
    attachedFiles.push(bytes);
  }
  return URL.createObjectURL(new Blob([await pdf.save()], { type: "application/pdf" }));
}
